import { render } from "./BannerNoticias.vue?vue&type=template&id=7b4d6fc7&scoped=true"
import script from "./BannerNoticias.vue?vue&type=script&lang=js"
export * from "./BannerNoticias.vue?vue&type=script&lang=js"

import "./BannerNoticias.vue?vue&type=style&index=0&id=7b4d6fc7&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.34_vue@3.5.34_webpack@5.106.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b4d6fc7"]])

export default __exports__